import React from 'react';
import {Link} from 'react-router-dom';
import {T} from '../../../utils/I18n/I18n';
import Button from '../../UI/Button/Button';

const AddressPresentation = ({address, addressType}) => {
    const {firstname, lastname, street, city, postcode, telephone} = address;
    let type = addressType === 'naplatu' ? 'naplatu' : 'dostavu';
    return (
        <div className="address__info mr-auto">
            <p className="mini-headers"><span><T id="personalData.setAddress"/> {type}</span></p>
            <div className="profile__address-data">
                <span>
                    {firstname} {lastname}
                </span>
                <span>{street && street.length > 0 && street[0]}</span>
                <span>
                    {city} {postcode}
                </span>
                <span>{<T id="personalData.country"/>}</span>
                <span>T: {telephone && telephone}</span>
            </div>
            <Link to="/customer/account/address/">
                <Button text={<T id="personalData.editAddress"/>} type="button" trait="profile"/>
            </Link>
        </div>
    );
};

export default AddressPresentation;
